import { render, staticRenderFns } from "./RifaPerfumadas.vue?vue&type=template&id=3fd832e9&scoped=true"
import script from "./RifaPerfumadas.vue?vue&type=script&lang=js"
export * from "./RifaPerfumadas.vue?vue&type=script&lang=js"
import style0 from "./RifaPerfumadas.vue?vue&type=style&index=0&id=3fd832e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd832e9",
  null
  
)

export default component.exports